const ModalAddUpdateUser = ({ editingUser, formData, handleInputChange, handleSubmit, setIsModalVisible, roles }) => {
   return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
         <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h2 className="text-xl font-semibold mb-4">{editingUser ? 'Sửa người dùng' : 'Thêm người dùng mới'}</h2>
            <form onSubmit={handleSubmit}>
               <div className="mb-4">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                     Tên người dùng:
                  </label>
                  <input
                     type="text"
                     id="name"
                     name="name"
                     value={formData.name}
                     onChange={handleInputChange}
                     required
                     disabled={!!editingUser}
                     className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${editingUser ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  />
               </div>
               <div className="mb-4">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                     Email:
                  </label>
                  <input
                     type="email"
                     id="email"
                     name="email"
                     value={formData.email}
                     onChange={handleInputChange}
                     required
                     disabled={!!editingUser}
                     className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${editingUser ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  />
               </div>
               <div className="mb-4">
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                     {editingUser ? 'Mật khẩu mới (để trống nếu không đổi):' : 'Mật khẩu:'}
                  </label>
                  <input
                     type="password"
                     id="password"
                     name="password"
                     value={formData.password}
                     onChange={handleInputChange}
                     required={!editingUser}
                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
               </div>
               <div className="mb-4">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                     Số điện thoại:
                  </label>
                  <input
                     type="text"
                     id="phone"
                     name="phone"
                     value={formData.phone}
                     onChange={handleInputChange}
                     required
                     disabled={!!editingUser}
                     className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${editingUser ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  />
               </div>
               <div className="mb-4">
                  <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                     Địa chỉ:
                  </label>
                  <input
                     type="text"
                     id="address"
                     name="address"
                     value={formData.address}
                     onChange={handleInputChange}
                     required
                     disabled={!!editingUser}
                     className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${editingUser ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  />
               </div>
               {!editingUser && (
                  <div className="mb-4">
                     <label htmlFor="role_id" className="block text-sm font-medium text-gray-700 mb-2">
                        Vai trò:
                     </label>
                     <select
                        id="role_id"
                        name="role_id"
                        value={formData.role_id}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                     >
                        <option value="" disabled>
                           Chọn vai trò
                        </option>
                        {roles.map((role) => (
                           <option key={role.role_id} value={role.role_id}>
                              {role.name}
                           </option>
                        ))}
                     </select>
                  </div>
               )}
               <div className="flex justify-end gap-3">
                  <button
                     type="submit"
                     className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded transition duration-200"
                  >
                     {editingUser ? 'Cập nhật' : 'Thêm'}
                  </button>
                  <button
                     type="button"
                     onClick={() => setIsModalVisible(false)}
                     className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded transition duration-200"
                  >
                     Hủy
                  </button>
               </div>
            </form>
         </div>
      </div>
   );
};

export default ModalAddUpdateUser;
